<script setup lang="ts">
const props = defineProps({
  error: Object,
})

interface StroyBlokError {
  items: {
    code: string
    title: string
    text: StoryBlokRichText
    image: StoryBlokImage
  }[]
  homeButton: StoryBlokButton[]
  tiles: any
}

const isMenuOpen = ref(false)

const sbApi = useStoryblokApiV2()
const data = (await sbApi.getStories<{ content: any; slug: 'error' | 'navigation' | 'footer' }>({
  by_slugs: ['layout/*'],
})).stories

const errorData: StroyBlokError = data.find(item => item.slug === 'error')?.content
const errorItems = errorData?.items || []
const errorItem = errorItems.find(item => Number(item.code) === props.error?.statusCode)
</script>

<template>
  <div>
    <TheNavigation
      v-model:is-menu-open="isMenuOpen"
      v-bind="data.find(item => item.slug === 'navigation')?.content"
    />
    <div class="py-4 md:py-10 bg-background">
      <div class="content-container">
        <div class="flex gap-4">
          <div class="flex flex-col justify-center gap-4">
            <h1>{{ errorItem?.title || 'Nespecifikovaná chyba' }}</h1>
            <StoryblokRichText :document="errorItem?.text" />
            <StoryblokButton v-bind="errorData.homeButton[0]" class="<sm:w-full" />
          </div>
          <div class="hidden lg:flex">
            <StoryblokImage v-if="errorItem?.image?.filename" :src="errorItem.image" width="440" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="errorData.tiles?.length" class="content-container">
      <StoryblokProductTiles
        v-editable="errorData.tiles[0].reference?.content || errorData.tiles[0]"
        class="my-14"
        v-bind="errorData.tiles[0].reference?.content || errorData.tiles[0]"
      />
    </div>
    <TheFooter v-bind="data.find(item => item.slug === 'footer')?.content" />
  </div>
</template>
